<!--Double navigation-->
<header class="print-d-none">
  <!-- Sidebar navigation -->
  <mdb-side-nav #sidenav class="sn-bg-4" [fixed]="true" [sidenavBreakpoint]="1440">
    <mdb-navbar-brand>
      <!-- Logo -->
      <li>
        <div class="logo-wrapper waves-light">
          <a href="#">
            <img src="assets/img/Logo-Isstec_blanco.png" class="img-fluid flex-center" />
          </a>
        </div>
      </li>
      <!--/. Logo -->
    </mdb-navbar-brand>

    <links>
      <!-- Side navigation links -->
      <li>
        <ul class="collapsible collapsible-accordion">
          <mdb-accordion [multiple]="false" aria-multiselectable="false">
            <!-- Dashboard-->
            <mdb-accordion-item class="no-collase" (click)="hideSidenavAfterClick()">
              <mdb-accordion-item-head routerLink="dashboards/v1" routerLinkActive="active" mdbWavesEffect>
                <i class="fa fa-hand-pointer-o"></i>Dashboard
              </mdb-accordion-item-head>
              <mdb-accordion-item-body></mdb-accordion-item-body>
            </mdb-accordion-item>
            <!-- Menu Dinamico-->
            <mdb-accordion-item *ngFor="let cat of categoriasMenu">
              <mdb-accordion-item-head mdbWavesEffect><i class="fa fa-chevron-right"></i>{{cat.categoria_nombre}}
              </mdb-accordion-item-head>
              <mdb-accordion-item-body>
                <ul *ngFor="let menu of moduloMenu">

                  <li *ngIf="cat.categoria_codigo == menu.categoria_codigo && menu.endpoint == 'separador'"
                    class="separador-menu"> {{menu.modulo_nombre}} </li>
                  <li
                    *ngIf="cat.categoria_codigo == menu.categoria_codigo && menu.endpoint != 'separador' && menu.operacion_codigo == 1">
                    <a routerLink="{{ menu.endpoint }}" routerLinkActive="active" class="waves-effect"
                      (click)="hideSidenavAfterClick()" mdbWavesEffect>{{ menu.modulo_nombre }}</a>
                  </li>
                </ul>
              </mdb-accordion-item-body>
            </mdb-accordion-item>
          </mdb-accordion>
        </ul>

      </li>
      <!--/. Side navigation links -->
    </links>
    <div class="sidenav-bg mask-strong"></div>
  </mdb-side-nav>
  <!--/. Sidebar navigation -->

  <!-- Navbar -->
  <mdb-navbar SideClass="navbar fixed-top navbar-expand-md navbar-light white double-nav scrolling-navbar"
    [containerInside]="false">
    <navlinks class="navbar-container">
      <!-- SideNav slide-out button -->
      <div class="float-left">
        <a (click)="sidenav.show()" class="button-collapse black-text">
          <i class="fa fa-bars"></i>
        </a>
      </div>
      <!--/. SideNav slide-out button -->
    </navlinks>

    <mdb-navbar-brand>
      <!-- Breadcrumb-->
      <div class="breadcrumbs breadcrumb-dn mr-auto black-text">
        <p>ISSTEC</p>
      </div>
      <!--/. Breadcrumb-->
    </mdb-navbar-brand>

    <navlinks>
      <ul class="nav navbar-nav nav-flex-icons ml-auto ie-double-nav">
        <li class="nav-item dropdown btn-group" dropdown>
          <a dropdownToggle type="button" class="nav-link dropdown-toggle waves-light" mdbWavesEffect>
            <mdb-icon fas icon="user-alt"></mdb-icon>
            <span class="clearfix d-none d-sm-inline-block mr-1">{{
              nombre_usuario
              }}</span>
          </a>
          <!-- <button (click)="sendMessage()">Enviar Mensaje</button>
          <div *ngFor="let message of receivedMessages">{{ message }}</div>
          <div *ngIf="errorMessage" style="color: red;">{{ errorMessage }}</div> -->
          <div class="dropdown-menu dropdown-primary dropdown-menu-right" role="menu">
            <a class="dropdown-item" href="#">Cuenta</a>
            <a class="dropdown-item" (click)="logout()">Cerrar sesión</a>
          </div>
        </li>

        <li class="nav-item btn-group" mdbDropdown #toggleButton
          (click)="toggleMenu($event)">
          <a mdbDropdownToggle type="button" class="nav-link dropdown-toggle waves-light" (click)="verNotificacion()"
            mdbWavesEffect>
            
            <span class="counter" *ngIf="countNotificaciones > 0">{{countNotificaciones}}</span>
            <mdb-icon fas icon="bell"></mdb-icon>
          </a>
          <div class="dropdown-menu dropdown-primary a-various-dropdown fadeInDropdown notificaciones-scroll" 
            style="max-width: 100%;" #menu>
            <div class="title-box">
              <strong>Notificaciones ({{listaMovimientos.length}})</strong>
              <!-- <a href="#">Filtrar por:</a> -->
            </div>
            <div *ngFor="let cat of not_groupArr">
              <strong class="title-section">{{cat.categoria_nombre}}</strong>
              <div *ngFor="let mov of cat.listanot_groupItem" class="dropdown-item notificacion class_a_href">
                <div [ngClass]="{'notificacionNueva':mov.estado_notificacion_codigo == 1}" class="left separador">
                  <div class="icon">
                    <mdb-icon far icon="bell"></mdb-icon>
                  </div>
                  <div [ngClass]="{'notificacionNueva':mov.estado_notificacion_codigo == 1}" class="info">
                    <strong>{{mov.tipo_notificacion_nombre}}</strong>
                    <p class="last-message text-muted"><a class="last-message text-muted mensage"
                        (click)="DownloadArchivo(mov.mensaje, mov)">{{mov.mensaje}}</a></p>
                    <p class="last-message text-muted" style="margin-bottom: 0px;">{{mov.fecha_registro| date}} -
                      {{mov.fecha_registro| date: 'shortTime'}}</p>
                  </div>
                  <div class="right">
                    <button (click)="eliminarNotificacion(mov)" mdbBtn type="buttobuttonn"
                      class='note-close close'><strong>x</strong></button>

                  </div>
                </div>
              </div>
            </div>
            <div class="title-box">
              <!-- <a href="notificaciones">Ver todas</a> -->
            </div>
          </div>
        </li>

        <li class="nav-item">
          <a class="nav-link waves-light" mdbWavesEffect>
            <mdb-icon fas icon="cog"></mdb-icon>
          </a>
        </li>
      </ul>
    </navlinks>
  </mdb-navbar>
  <!--/. Navbar -->
</header>
<!--/.Double navigation-->
<app-signalr-service></app-signalr-service>
